import { Component, Injectable } from '@angular/core';

@Injectable()
export class FormioLoader {
  public loading: boolean = true;
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/formio.loader.ts